import store_medicaments from "@/store/mods/stock/medicaments"
import EnteteBonEtFacture from '@/views/en-tete-bon-facture'

export default {
    name: 'commandes',
    components: {
        EnteteBonEtFacture
    },
    props: [],
    data() {
        return {
            orders: [], 
            grouped_orders: [],
            order_is_empty: false,
            order_is_loading: true,

            fields: [
                { key: 'no', label: 'N°' },
                { key: 'libelle', label: 'Produit' },
                { key: 'type_article', label: 'Type article' },
                { key: 'stock_minimum', label: 'Seuil minimum' },
                { key: 'stock_maximum', label: 'Seuil optimal' },
                { key: 'quantite', label: 'Qté' },
                { key: 'quantite_a_commander', label: 'Qté à commander' }
            ],
            currentPage: 1,
            perPage: -1,
            print_per_page: -1,
            filter: '',

            is_printing: false,
            is_exporting: false,

            json_fields: {
                'N°': 'no',
                'Produit': 'libelle',
                'Seuil minimum': 'stock_minimum',
                'Seuil optimal': 'stock_maximum',
                'Qté': 'quantite',
                'Qté à commander': 'quantite_a_commander',
            },

            json_data: [],
            export_filename: 'Liste_Conmmande.xls',
            can_print: false,
            quantite_a_commander: []
        }
    },

    computed: {

    },

    mounted() {
        this.getOrders()

        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },

    methods: {
        getOrders() {
            this.order_is_loading = true
            this.grouped_orders = []
            store_medicaments.getListeArticeACommander().then((response) => {
                this.orders = response

                if (this.orders.length == 0) {
                    this.order_is_empty = true
                } else {
                    this.order_is_empty = false

                    this.orders.forEach((order, index) => {
                        this.quantite_a_commander[index] = order.quantite_a_commander
                    });

                    // Setting the json data for export
                    // this.setExportingData()

                    // const tmp_grouped_orders = this.orders.groupBy('type_article')
                    // for (const key in tmp_grouped_orders) {
                    //     let tmp_type_article = ''
                    //     if (key == 'medicament') {
                    //         tmp_type_article = 'Médicaments'
                    //     } else if (key == 'consommable') {
                    //         tmp_type_article = 'Consommables'
                    //     } else {
                    //         tmp_type_article = 'Autres'
                    //     }
                    //     const tmp = {
                    //         type_article: tmp_type_article,
                    //         articles: tmp_grouped_orders[key]
                    //     }
                    //     this.grouped_orders.push(tmp)
                    // }
                    // console.log("Grp orders: ", this.grouped_orders)
                }
                this.order_is_loading = false
            })
        }, 

        updateQte(index) {
            const input_qty = document.getElementById('qty-'+index)
            if (!input_qty) {
                return;
            }

            let qty = input_qty.value
            qty = this.cleanNumber(qty)

            if (qty === ''){
                qty = 0
            }
            console.log(">>> ",qty);
            
            this.quantite_a_commander[index] = qty
        },

        handleBeforeGenerate() {
            this.setExportingData()

            let d = new Date()
            this.export_filename = 'Liste_Commande_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        setExportingData() {
            console.log(this.quantite_a_commander);
            
            this.json_data = []
            this.orders.forEach((order, index) => {
                this.json_data.push({
                    'no': index + 1,
                    'libelle': order.libelle,
                    'stock_minimum': (order.stock_minimum > 0) ? order.stock_minimum : '',
                    'stock_maximum': (order.stock_maximum > 0) ? order.stock_maximum : '',
                    'quantite': order.quantite,
                    'quantite_a_commander': this.quantite_a_commander[index]
                })
            })
        },

        printOrder() {
            this.can_print = true
            this.is_printing = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
                this.is_printing = false
            }, 500);
        },
    }
}